var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file Component: TableBody
 * @author wangzixi@baidu.com
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';

/**
 * component: string      生成元素的类型，默认为 table
 */

var TableBody = function (_Component) {
    _inherits(TableBody, _Component);

    function TableBody() {
        _classCallCheck(this, TableBody);

        return _possibleConstructorReturn(this, (TableBody.__proto__ || Object.getPrototypeOf(TableBody)).apply(this, arguments));
    }

    _createClass(TableBody, [{
        key: 'getChildContext',
        value: function getChildContext() {
            return {
                table: {
                    body: true
                }
            };
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                Wrapper = _props.component,
                children = _props.children,
                otherProps = _objectWithoutProperties(_props, ['component', 'children']);

            return React.createElement(
                Wrapper,
                otherProps,
                children
            );
        }
    }]);

    return TableBody;
}(Component);

TableBody.defaultProps = {
    component: 'tbody'
};
TableBody.propTypes = {
    component: PropTypes.string,
    children: PropTypes.node
};
TableBody.childContextTypes = {
    table: PropTypes.object
};
export default TableBody;